import React, {PropTypes} from 'react';


class RhinoSelect extends React.Component {

  static defaultProps = {
    blurMethod: () => {},
    disabled: false,
    error: false,
    value: null,
    selectClass: null,
  };

  static propTypes = {
    blurMethod: PropTypes.func,
    changeMethod: PropTypes.func,
    disabled: PropTypes.bool,
    error: PropTypes.bool,
    options: PropTypes.array.isRequired,
    value: PropTypes.any,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  getParentClass() {
    let baseClass = 'RhinoSelect';
    if(this.props.selectClass) {
      baseClass = baseClass + ' ' + this.props.selectClass;
    }
    if(this.props.error) {
      baseClass = baseClass + ' error';
    }
    return baseClass;
  }

  render() {
    return (
      <div className={this.getParentClass()}>
        <select 
          disabled={this.props.disabled}
          onBlur={::this.props.blurMethod}
          onChange={::this.props.changeMethod}
          defaultValue={this.props.value !== null ? this.props.value : this.props.options[0].value}>
          {this.props.options.map((option, i) => {
            return <option 
              key={i} 
              value={option.value}
              className={!option.value ? 'defaultOption' : 'selectableOption'}>
              {option.display}
            </option>;
          })}
        </select>
        <div className='select__arrow'></div>
      </div>
    );
  }
}
export default RhinoSelect;


// WEBPACK FOOTER //
// ./src/components/common/inputs/RhinoSelect.jsx